@if (form) {
  <div [formGroup]="form" class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <label for="label" class="font-semibold w-full">{{ "gate_components.make_form.label" | translate }}*</label>
      <input pInputText id="label" formControlName="label" autocomplete="off" (keyup)="onKeyUp($event)" />
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button
        buttonText="common.save"
        [disabled]="!form.valid || requestStarted()"
        (click)="save()"
        [loading]="requestStarted()"
      ></app-button>
    </div>
  </div>
}
